(() => {
  'use strict';
  const button = document.getElementById('s92-whatsapp-support');
  if (!button || button.dataset.ready === 'true') return;
  button.dataset.ready = 'true';
  const phone = '919996457318';
  const nudge = document.getElementById('s92-support-nudge');
  const nudgeLink = document.getElementById('s92-support-nudge-link');

  function refreshLink() {
    try {
      const current = new URL(window.location.href);
      const origin = new URL(button.dataset.storeOrigin || current.origin).origin;
      const url = new URL(current.pathname, origin);
      let title = (document.title || button.dataset.pageTitle || 'Sterling92').replace(/[\r\n]+/g, ' ').trim();
      const privatePage = /\/(?:account|orders|checkouts)(?:\/|$)/i.test(url.pathname);
      if (privatePage) {
        url.pathname = /\/account(?:\/|$)/i.test(url.pathname) ? '/account' : '/';
        title = 'Store support';
      } else {
        if (/\/cart\//i.test(url.pathname)) url.pathname = '/cart';
        const productPage = /\/products\/[^/]+\/?$/.test(url.pathname);
        const listingPage = /\/(?:collections|search)(?:\/|$)/.test(url.pathname) && !productPage;
        for (const [key, value] of current.searchParams) {
          const numericVariant = productPage && key === 'variant' && /^\d+$/.test(value);
          const productOptions = productPage && key === 'option_values' && /^\d+(,\d+)*$/.test(value);
          const listingState = listingPage && (['q', 'type', 'sort_by', 'page', 'options[prefix]'].includes(key) || key.startsWith('filter.'));
          if (numericVariant || productOptions || listingState) url.searchParams.append(key, value.slice(0, 500));
        }
        if (productPage) {
          const selected = document.querySelector('#MainContent .product-information form[action*="/cart/add"] [name="id"]');
          if (selected && /^\d+$/.test(selected.value)) {
            url.searchParams.set('variant', selected.value);
            url.searchParams.delete('option_values');
          }
        }
      }
      // Allow-list above deliberately excludes preview, tracking and session data.
      const message = `Hi Sterling92, I would like help with this page:\n${title.slice(0, 240)}\n${url.href}`;
      button.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      if (nudgeLink) nudgeLink.href = button.href;
    } catch (_) {
      // Keep the server-rendered link if browser URL handling fails.
    }
  }

  // Native anchor navigation avoids popup blockers and an unnecessary intermediate UI.
  // Recompute at activation so variant/filter updates never leave a stale page link.
  for (const type of ['pointerdown', 'click', 'auxclick', 'focus', 'contextmenu']) {
    button.addEventListener(type, refreshLink);
    if (nudgeLink) nudgeLink.addEventListener(type, refreshLink);
  }
  window.addEventListener('pageshow', refreshLink);
  window.addEventListener('popstate', refreshLink);
  refreshLink();

  let frame = 0;
  function placeButton() {
    frame = 0;
    let bottom = 18;
    const viewportHeight = window.innerHeight;
    const anchorBox = button.getBoundingClientRect();
    // Stay above Shopify's draft-preview bar and the existing sticky add-to-cart bar.
    for (const element of document.querySelectorAll('#preview-bar-iframe, #shopify-preview-bar, sticky-add-to-cart [data-stuck="true"]')) {
      const box = element.getBoundingClientRect();
      const visible = getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none';
      if (visible && box.height > 0 && box.width > 0 && box.top < viewportHeight && box.top > viewportHeight / 2 && box.bottom > viewportHeight - 220 && box.right > anchorBox.left && box.left < anchorBox.right) {
        bottom = Math.max(bottom, viewportHeight - box.top + 12);
      }
    }
    const value = `${Math.ceil(bottom)}px`;
    if (button.style.getPropertyValue('--s92-support-bottom') !== value) button.style.setProperty('--s92-support-bottom', value);
    if (nudge && nudge.style.getPropertyValue('--s92-support-bottom') !== value) nudge.style.setProperty('--s92-support-bottom', value);
  }
  function queuePlacement() {
    if (!frame) frame = requestAnimationFrame(placeButton);
  }
  window.addEventListener('resize', queuePlacement, { passive: true });
  window.addEventListener('scroll', queuePlacement, { passive: true });
  window.addEventListener('load', queuePlacement, { once: true });
  const observer = new MutationObserver(queuePlacement);
  for (const element of document.querySelectorAll('sticky-add-to-cart')) {
    observer.observe(element, { attributes: true, subtree: true, attributeFilter: ['data-stuck', 'style', 'hidden'] });
  }
  observer.observe(document.body, { childList: true });
  queuePlacement();

  // One gentle mobile invitation per tab session, not on every page/variant change.
  // Dismissal never opens WhatsApp; both links retain their one-click navigation.
  if (!nudge || !nudgeLink) return;
  const close = document.getElementById('s92-support-nudge-close');
  if (!close) return;
  const mobile = window.matchMedia('(max-width: 749px)');
  const sessionKey = 's92-wa-support-nudge-v1';
  let seen = false;
  let showTimer = 0;
  let hideTimer = 0;
  let hovered = false;
  let returningFocus = false;
  try { seen = sessionStorage.getItem(sessionKey) === '1'; } catch (_) { /* Storage may be blocked. */ }

  function remember() {
    seen = true;
    try { sessionStorage.setItem(sessionKey, '1'); } catch (_) { /* Current-page fallback. */ }
  }
  function isBusy() {
    const active = document.activeElement;
    const typing = active instanceof Element && active.matches('textarea, select, [contenteditable="true"], input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="range"])');
    return typing || Boolean(document.querySelector('dialog[open], theme-drawer[open]'));
  }
  function hideNudge() {
    clearTimeout(hideTimer);
    nudge.hidden = true;
    hovered = false;
  }
  function hasFocus() {
    return document.activeElement === button || nudge.contains(document.activeElement);
  }
  function armHide() {
    clearTimeout(hideTimer);
    if (!nudge.hidden && !hovered && !hasFocus()) hideTimer = window.setTimeout(hideNudge, 8000);
  }
  function showNudge() {
    if (!mobile.matches || document.hidden || isBusy()) return;
    refreshLink();
    queuePlacement();
    nudge.hidden = false;
    remember();
    armHide();
  }
  function scheduleNudge() {
    clearTimeout(showTimer);
    if (!mobile.matches || document.hidden || isBusy()) {
      hideNudge();
      return;
    }
    if (!seen) showTimer = window.setTimeout(showNudge, 3000);
  }
  function dismiss() {
    remember();
    clearTimeout(showTimer);
    const restoreFocus = nudge.contains(document.activeElement);
    hideNudge();
    if (restoreFocus) {
      returningFocus = true;
      button.focus({ preventScroll: true });
      returningFocus = false;
    }
  }
  close.addEventListener('click', dismiss);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !nudge.hidden) dismiss();
  });
  button.addEventListener('click', () => { remember(); clearTimeout(showTimer); hideNudge(); });
  nudgeLink.addEventListener('click', () => { remember(); clearTimeout(showTimer); });

  // Do not time out while someone is reading with a pointer or keyboard.
  for (const element of [button, nudge]) {
    element.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      hovered = true;
      if (nudge.hidden) showNudge();
      clearTimeout(hideTimer);
    });
    element.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      hovered = false;
      armHide();
    });
    element.addEventListener('focusin', () => {
      if (returningFocus) return;
      if (element === button && button.matches(':focus-visible')) showNudge();
      clearTimeout(hideTimer);
    });
    element.addEventListener('focusout', () => { queueMicrotask(armHide); });
  }
  document.addEventListener('focusin', scheduleNudge);
  document.addEventListener('focusout', () => { queueMicrotask(scheduleNudge); });
  document.addEventListener('visibilitychange', scheduleNudge);
  document.addEventListener('toggle', scheduleNudge, true);
  for (const type of ['theme-drawer:open', 'theme-drawer:close']) document.addEventListener(type, scheduleNudge);
  window.addEventListener('pageshow', scheduleNudge);
  mobile.addEventListener('change', scheduleNudge);
  scheduleNudge();
})();
